import styles from './AdminModule.module.scss';
import { Outlet } from 'react-router-dom';

import { clsxm } from '@app/styles/clsxm';

import { Header } from '@app/layout/header/Header';
import { AdminSidebarMenu } from '@app/layout/admin-sidebar-menu/AdminSidebarMenu';
import { useStore } from '@app/store/useStore.hook';

export const AdminModule = () => {
  const { isDesktop } = useStore.useCurrentBreakpointDevice();

  return (
    <div className={styles.root}>
      <Header />
      <div className={styles['app-content']}>
        <AdminSidebarMenu />
        <main className={clsxm('w-full pb-20', isDesktop && 'pl-[260px]')}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
